// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 945 ? "dashboard" : chunkId) + "." + {"602":"2b36edb1","945":"8ef7f46a"}[chunkId] + ".chunk.css";
};